import { styled } from '@mui/material/styles';
import { Dialog, AppBar, Toolbar, DialogContent, DialogActions } from '@mui/material';

const IMAGE = 100;

export const AlertTemplate = styled('div')({
  '& .MuiAlert-message': {
    width: '100%',
    alignItems: 'center',
  },
});

export const TemplateButtonContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),

  '& button': {
    marginRight: theme.spacing(1),
  },
}));

export const TemplateContainer = styled('div')(({ theme }) => ({
  '& h2': {
    fontWeight: 'bold',
    fontSize: 20,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  '& .systemIcon': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: theme.spacing(2),

    '& .MuiSvgIcon-root': {
      borderRadius: 20,
      padding: 5,
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      marginRight: theme.spacing(1),
    },
  },
  '& .textContainer': {
    marginTop: theme.spacing(4),
  },
  '& .textDivider': {
    width: '100%',
    clear: 'both',
    fontSize: 13,
    marginBottom: theme.spacing(2),

    '& .left': {
      width: '50%',
      boxSizing: 'border-box',

      '& .leftTitle': {
        fontWeight: 'bold',
      },
    },
    '& .right': {
      boxSizing: 'border-box',
      width: '50%',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',

      '& .IMAGE': {
        marginRight: 2,
        marginBottom: 2,
      },
    },
  },
}));

export const HlcDialog = styled(Dialog)({
  zIndex: '1000 !important',
  overflowY: 'hidden',

  '& .MuiDialog-paperScrollPaper, .MuiDialog-scrollPaper': {
    overflowY: 'hidden',
  },

  // Form class hooks
  '& .hlc-form-style': {
    position: 'relative',
    maxWidth: '1000px !important',
    overflow: 'visible !important',
    height: 'auto',
    display: 'block',

    '& .MuiFormControl-root': {
      paddingTop: 0,
    },
  },
  '& .hlc-title-style': {
    fontSize: '18px !important',
    fontWeight: 'bold',
    marginBottom: 0,
  },
  '& .hlc-screen-width': {
    width: '100%',
  },
  '& .hlc-screen-container': {
    maxWidth: 'none !important',
  },
});

export const HlcAppBar = styled(AppBar)({
  position: 'relative',
});

export const HlcToolbar = styled(Toolbar)({
  height: 70,
});

export const HlcTitle = styled('span')({
  margin: 0,
  padding: 0,
  lineHeight: 1.2,
  fontWeight: 'bold',
});

export const HlcContainer = styled(DialogContent)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),
  width: '80%',
  maxWidth: 650,
  margin: '0 auto',
}));

export const HlcContainerDiv = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),
  width: '80%',
  maxWidth: 650,
  margin: '0 auto',
}));

export const BarTitle = styled('div')(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  marginLeft: theme.spacing(2),
}));

export const SubmitButtonContainer = styled(DialogActions)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  margin: theme.spacing(1),
  marginTop: theme.spacing(2),

  '& button': {
    marginLeft: theme.spacing(2),
  },
}));

export const SubmitBtnText = styled('span')({
  maxWidth: 90,
});

// Class-name strings passed to Form
export const HLC_FORM_STYLE = 'hlc-form-style';
export const HLC_TITLE_STYLE = 'hlc-title-style';
export const HLC_SCREEN_WIDTH = 'hlc-screen-width';
export const HLC_SCREEN_CONTAINER = 'hlc-screen-container';
